import EditingMainHeader from "../../components/addOns/headers/EditingMainHeader";
import { useNavigate, useParams } from "react-router-dom";
import InvoiceFormContainer from "../../components/customer/invoices/invoice/form/invoiceFormContainer";
import RecapContainer from "../../components/customer/invoices/invoice/recap/recapContainer";
import { useContext, useEffect, useRef, useState } from "react";
import { GetApiContext } from "../../context/apiCalls/getApiCalls";
import { PostApiContext } from "../../context/apiCalls/postApiCalls";
import { PdfContext } from "../../context/PdfContext";
import { AppContext } from "../../context/appContext";
import Decimal from "decimal.js";
import { safeNumber } from "../../utils/calculations";
import { generateId } from "../../utils/generateId";
import Loader from "../../components/addOns/loader";
import { useAuthState } from "../../context/authContext";
import { getCurrentDate } from "../../utils/utils";
import { format } from "date-fns";
import MailPop from "../../components/addOns/MailPop";
import { toast } from "react-toastify";
import Calendar from "react-calendar";

function Invoice() {
  const { userId, roleId } = useAuthState();
  const { id } = useParams();
  const navigate = useNavigate();
  const getApiContext = useContext(GetApiContext);
  const postApiContext = useContext(PostApiContext);
  const appContext = useContext(AppContext);
  const pdfContext = useContext(PdfContext);

  const [invoice, setInvoice] = useState({});
  const [interlocutorsList, setInterlocutorsList] = useState([]);
  const [vatList, setVatList] = useState([]);
  const [contactId, setContactId] = useState("");
  const [groups, setGroups] = useState([]);
  const [interlocutorId, setInterlocutorId] = useState("");
  const [totalInvoice, setTotalInvoice] = useState(0);
  const [unitsList, setUnitsList] = useState([]);
  const [showCalendar, setShowCalendar] = useState(false);
  const [newListTva, setNewListTva] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [linkDeposit, setLinkDeposit] = useState();
  const [margin, setMargin] = useState(0);
  const [discountPrice, setDiscountPrice] = useState(0);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);

  // refs
  const refRef = useRef("");
  const titleRef = useRef("");
  const dateRef = useRef(getCurrentDate());

  const formDatas = {
    titleRef,
    setContactId,
    setInterlocutorId,
  };

  const getApiContextRef = useRef(getApiContext);
  const groupsRef = useRef(groups);
  const invoiceRef = useRef(invoice);
  const vatListRef = useRef(vatList);
  const newListTvaRef = useRef(newListTva);
  // Mise à jour des références pour éviter les problèmes de closure dans les useEffect
  useEffect(() => {
    getApiContextRef.current = getApiContext;
    groupsRef.current = groups;
    invoiceRef.current = invoice;
    vatListRef.current = vatList;
    newListTvaRef.current = newListTva;
  }, [getApiContext, groups, invoice, vatList, newListTva]);
  // Chargement initial de la facture (existante ou nouvelle)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    setLoading(true);
    if (id) {
      getApiContextRef.current.getInvoice(id).then((data) => {
        // console.log(data);
        if (!data.error) {
          dateRef.current = data.invoice?.invoiceDate;
          setInterlocutorsList(data.listInterlocutors);
          setInvoice(data.invoice);

          setVatList(data.listTva);
          setUnitsList(data.unitList);
          setRefresh(false);
          setMargin(data.margin);
          setLinkDeposit(data.deposit);
          setComment(data.invoice?.comment);
          if (newListTvaRef.current?.length < 1) {
            setNewListTva(data.listTva);
          }
        }
      });
    } else {
      refRef.current.value = "FAC" + format(new Date(), "dMyyms");
      let newInvoice = { ...invoiceRef.current };
      let newId = generateId(groupsRef.current);
      if (!newInvoice.groups) newInvoice.groups = [];
      newInvoice.groups.push({
        id: newId,
        invoiceId: invoiceRef.current.id,
        lines: [
          {
            id: newId,
            invoiceGroupId: newId,
            itemId: null,
            name: "",
            numero: 1,
            quantity: 0,
            unitId: 1,
            unitPrice: 0,
            vatId: vatListRef.current[0]?.id ?? "0",
            total: 0,
          },
        ],
        numero: groupsRef.current.length + 1 || 1,
        title: "",
      });
      setInvoice(newInvoice);
      getApiContextRef.current.getInterlocutorsList().then((data) => {
        setInterlocutorsList(data?.data);
      });
      getApiContextRef.current.getVatList().then((data) => {
        if (data) {
          setVatList(data?.data);
        }
      });
      getApiContextRef.current.getUnitsList().then((data) => {
        setUnitsList(data.data);
      });
    }    setLoading(false);
  }, [id, refresh]);

  // Calcul des montants de TVA pour chaque ligne avec prise en compte de la remise
  useEffect(() => {
    let newInvoice = { ...invoiceRef.current };
    if (invoiceRef.current?.groups) {
      let newListTva = [...vatListRef.current];
      for (let k = 0; k < newListTva.length; k++) {
        newListTva[k].value = 0;
      }
      let discount = parseFloat(invoiceRef.current.discount || 0);
      newInvoice.groups.forEach((grp) => {
        grp.lines.forEach((line) => {
          for (let k = 0; k < newListTva.length; k++) {
            if (newListTva[k].id === line.vatId) {
              // Validation et nettoyage des valeurs
              const quantity = parseFloat(line.quantity || 0);
              const unitPrice = parseFloat(line.unitPrice || 0);
                // Vérification que les valeurs sont valides (permettre 0 pour le prix unitaire)
              if (!isNaN(quantity) && !isNaN(unitPrice) && quantity >= 0 && unitPrice >= 0) {
                let totalAmount = quantity * unitPrice;
                let totalAmountRemised = totalAmount * (1 - discount / 100);
                let lineTva = (totalAmountRemised * newListTva[k].rate) / 100;
                
                // Vérification que le calcul de TVA est valide
                if (!isNaN(lineTva) && lineTva >= 0) {
                  newListTva[k].value += lineTva;
                  newListTva[k].value = parseFloat(newListTva[k].value.toFixed(2));
                }
              }
            }
          }
        });
      });      setNewListTva(newListTva);
    }
  }, [groups, vatList, invoice?.discount]);

  // Calcul des totaux HT et TTC avec gestion de la remise globale
  useEffect(() => {
    let newInvoice = { ...invoiceRef.current };
    if (invoiceRef.current?.groups || totalInvoice > 0) {
      // Calcul du totalHt avec ou sans remise
      let calculatedTotalHt = totalInvoice;
      if (invoiceRef.current.discount && invoiceRef.current.discount > 0) {
        let total = new Decimal(totalInvoice);
        let discount = new Decimal(invoiceRef.current.discount);
        const pourcentTotalDiscount = total.mul(discount.div(100)).toNumber();
        calculatedTotalHt = total.minus(pourcentTotalDiscount).toNumber();
      }
      newInvoice.totalHt = parseFloat(calculatedTotalHt.toFixed(2));
      
      // Calcul du total TTC
      let amountTotalTva = 0;
      for (let k = 0; k < newListTva.length; k++) {
        amountTotalTva += newListTva[k].value;
      }
      newInvoice.totalTtc = parseFloat((newInvoice.totalHt + amountTotalTva).toFixed(2));
      
      // Mise à jour seulement si les valeurs ont vraiment changé
      const hasChanged = 
        invoiceRef.current.totalHt !== newInvoice.totalHt || 
        invoiceRef.current.totalTtc !== newInvoice.totalTtc ||
        invoiceRef.current.discount !== newInvoice.discount;
        
      if (hasChanged) {
        setInvoice(newInvoice);
      }
    }
  }, [totalInvoice, newListTva, invoice?.discount]);

  async function createDeposit(e) {
    e.preventDefault();
      const values = {
        quoteId: invoice.quoteId,
        refQuote: invoice.refQuote,
        ref: refRef.current?.value,
        contactId: contactId ? contactId : invoice.contact?.id,
        invoiceDate: dateRef.current ?? invoice.invoiceDate,
        title: titleRef.current?.value,
        interlocutor: interlocutorId ?? invoice.userId ?? userId,
        discount: invoice.discount ? invoice.discount : 0,
        deposit: invoice.deposit,
        comment: comment,
        totEstimateHours: margin.estimatedHours,
        averageHourlyRate: margin.averageHourlyRateHT,
        purchaseCosts: margin.purchaseCostsHT,
        fixedCosts: margin.fixedCosts,
        variableCosts: margin.variableCosts,
        totalHt: invoice.totalHt,
        totalTtc: invoice.totalTtc,
        groups: groups,
        createDeposit: 1,
      };
      try {
        const response = await postApiContext.postInvoice(values, id);
        // console.log("response", response);
        if (response?.deposit && response?.deposit[0]?.id) {
          toast.success("La facture et l'acompte ont bien été créés");
          // Met à jour l'URL et le parentPath
          localStorage.setItem("parentPath", "/invoicesList/invoice/" + response.invoice.id);
          // navigate("/invoicesList/invoice/" + response.invoice.id);
          return response.deposit[0].id;
        } else {
          console.error("Erreur lors de la création de la facture et de l'acompte", response);
          toast.error("Une erreur est survenue lors de la création de la facture et de l'acompte");
          return null;
        }
      } catch (error) {
        console.log(error);
        toast.error("Erreur lors de la création de la facture et de l'acompte");
        return null;
      }
  }

  const handleSubmitInvoice = async (e, path = "/invoicesList") => {
    e?.preventDefault();

    if (invoice?.totalHt < 0 || invoice?.totalTtc < 0) {
      toast.error("Le total d'une facture ne peut pas être négatif");
      return;
    }

    if (interlocutorId || invoice.userId || userId) {
      const values = {
        quoteId: invoice.quoteId,
        refQuote: invoice.refQuote,
        ref: refRef.current?.value,
        contactId: contactId ? contactId : invoice.contact?.id,
        invoiceDate: dateRef.current ?? invoice.invoiceDate,
        title: titleRef.current?.value,
        interlocutor: interlocutorId ?? invoice.userId ?? userId,
        discount: invoice.discount ? invoice.discount : 0,
        deposit: invoice.deposit,
        comment: comment,
        totEstimateHours: margin.estimatedHours,
        averageHourlyRate: margin.averageHourlyRateHT,
        purchaseCosts: margin.purchaseCostsHT,
        fixedCosts: margin.fixedCosts,
        variableCosts: margin.variableCosts,
        totalHt: invoice.totalHt,
        totalTtc: invoice.totalTtc,
        groups: groups,
        paymentDate: invoice.paymentDate,
        createMargin: path.includes("margin") ? 1 : 0,
        createDeposit: path.includes("deposit") ? 1 : 0,
      };

      postApiContext.postInvoice(values, id).then((data) => {
        localStorage.setItem(
          "parentPath",
          "/invoicesList/invoice/" + data?.invoice?.id
        );
        data?.invoice?.id ? id ? toast.success("La facture a bien été enregistrée") : toast.success("La facture a bien été créée") : toast.error("Une erreur est survenue lors de l'enregistrement de la facture");
        if (data && path.includes("margin")) {
          path = path + (data.margin?.id ?? "");
        }
        navigate(path);
      });
    } else {
      console.log(interlocutorId, invoice.userId);
      alert("Veuillez renseigner un interlocuteur");
    }
  };  const handleDiscountChange = (e) => {
    const discountValue = e?.target?.value || 0;
    
    // Ne mettre à jour que si la valeur a vraiment changé
    if (discountValue !== invoice?.discount) {
      setInvoice((prev) => {
        const newInvoice = { ...prev };
        newInvoice.discount = discountValue;
        
        // Recalcul immédiat du totalHt
        if (discountValue && totalInvoice > 0) {
          const total = new Decimal(safeNumber(totalInvoice));
          const discount = new Decimal(safeNumber(discountValue));
          const pourcentTotalDiscount = total.mul(discount.div(100)).toNumber();
          const totalDiscount = total.minus(pourcentTotalDiscount).toNumber();
          newInvoice.totalHt = parseFloat(totalDiscount.toFixed(2));
        } else {
          newInvoice.totalHt = parseFloat(totalInvoice.toFixed(2));
        }
        
        return newInvoice;
      });
    }
  };
  const handleDiscountBlur = (e) => {
    const discountValue = e.target.value;
    
    if (discountValue && totalInvoice > 0) {
      let discountPercent = parseFloat(discountValue);
      let discountPrice = new Decimal(totalInvoice)
        .mul(discountPercent)
        .div(100)
        .toNumber();
      setDiscountPrice(discountPrice);
    } else {
      setDiscountPrice(0);
    }
  };

  const duplicateInvoice = () => {
    handleSubmitInvoice(null, "");
    console.log("----------------submit---------------");
    getApiContext.getInvoice("", id).then((response) => {
      console.log("reponse dup", response);
      const invoice = response?.invoice;
      if (invoice?.id !== undefined) {
        navigate(`/invoicesList/invoice/${invoice?.id}`);
      }
    });
  };

  const handleOpenDelivery = (e) => {
    const invoiceId = id;
    getApiContext
      .getDelivery(null, invoiceId, null)
      .then((response) => {
        console.log("response", response);
        const delivery = response.delivery;
        if (delivery && delivery.id) {
          navigate(`/invoicesList/deliveriesList/delivery/${delivery?.id}`);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const headerButtonsList = {
    dropdown: {
      telecharger: {
        content: "Télécharger",
        handleClick: () => pdfContext.handlePDF("invoice", id, false),
        redir: false,
      },
      imprimer: {
        content: "Imprimer",
        handleClick: () =>  pdfContext.handlePDF("invoice", id, true),
        redir: false,
      },
      envoyer: {
        content: "Envoyer",
        handleClick: () => {
          appContext.setShowMailPop(true);
        },
        redir: false,
      },
      duplicate: {
        handleClick: duplicateInvoice,
        content: "Dupliquer",
        redir: "/invoicesList",
      },
      delivery: {
        handleClick: handleOpenDelivery,
        icon: "faClipboardList",
        content: "Créer un bon de livraison",
        redir: "/deliveriesList",
      },
    },
    mainButton: {
      buttonIcon: "sauvegarder",
      buttonText: id ? "Sauvegarder" : "Créer la facture",
      buttonAction: handleSubmitInvoice,
      className: "hide-text"
    },
  };

  const deleteDeposit = async (id) => {
    try {
      let response = await postApiContext.desactivateDeposit(id);
      if (response.status === "success") {
        let newLinkDeposit = [...linkDeposit];
        let index = newLinkDeposit.findIndex((deposit) => deposit.id === id);
        newLinkDeposit.splice(index, 1);
        setLinkDeposit(newLinkDeposit);
        toast.success("L'acompte a bien été supprimé");
      } else {
        toast.error("Une erreur est survenue lors de la suppression de l'acompte");
      }
    } catch (error) {
      console.error(error);
      toast.error("Une erreur est survenue lors de la suppression de l'acompte");
    }
  };
  const handleTvaClick = (tva) => {
    setInvoice((prevInvoice) => {
      if (!prevInvoice.groups) return prevInvoice;
      const updatedGroups = prevInvoice.groups.map((group) => ({
        ...group,
        lines: group.lines.map((line) => ({
          ...line,
          vatId: tva.id,
        })),
      }));

      // Recalculate totals avec prise en compte de la remise
      let newListTva = [...vatList];
      for (let k = 0; k < newListTva.length; k++) {
        newListTva[k].value = 0;
      }
      const discount = parseFloat(prevInvoice.discount || 0);
      updatedGroups.forEach((grp) => {
        grp.lines.forEach((line) => {
          for (let k = 0; k < newListTva.length; k++) {
            if (newListTva[k].id === line.vatId) {
              let totalAmount = parseFloat(line.quantity) * parseFloat(line.unitPrice);
              let totalAmountRemised = totalAmount * (1 - discount / 100);
              let lineTva = (totalAmountRemised * newListTva[k].rate) / 100;
              newListTva[k].value += lineTva;
              newListTva[k].value = parseFloat(newListTva[k].value.toFixed(2));
            }
          }
        });
      });

      let amountTotalTva = 0;
      for (let k = 0; k < newListTva.length; k++) {
        amountTotalTva += newListTva[k].value;
      }

      const totalHt = prevInvoice.totalHt || 0;
      const totalTtc = parseFloat(totalHt) + parseFloat(amountTotalTva);

      setTimeout(() => {
        setInvoice({ ...prevInvoice, groups: updatedGroups, totalTtc });
      }, 0);

      return { ...prevInvoice, groups: updatedGroups, totalTtc };
    });
  };

    const handleCalendarChange = (date) => {
      // Format date to yyyy-mm-dd en local (évite le décalage UTC)
      const formatted = date instanceof Date
        ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
        : date;
      dateRef.current = formatted;
      setInvoice((prevInvoice) => ({
        ...prevInvoice,
        paymentDate: formatted,
      }));
      setShowCalendar(false);
    };

  useEffect(() => {
    document.body.style.overflow = showCalendar ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";    };
  }, [showCalendar]);

  // Gestion de l'affichage du calendrier (blocage du scroll)
  useEffect(() => {
    document.body.style.overflow = showCalendar ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showCalendar]);

  // Recalcul du montant après remise pour chaque ligne à chaque changement de remise
  useEffect(() => {
    if (invoiceRef.current?.groups && invoice?.discount !== undefined) {
      let discount = parseFloat(invoice.discount || 0);
      // On ne met à jour les groupes QUE si la remise a vraiment changé
      const hasDiscountChanged = invoiceRef.current.discount !== invoice.discount;
      
      if (hasDiscountChanged && groupsRef.current) {
        let updatedGroups = groupsRef.current.map((grp) => ({
          ...grp,
          lines: grp.lines.map((line) => {
            const totalRemised = (parseFloat(line.quantity) * parseFloat(line.unitPrice) * (1 - discount / 100)).toFixed(2);
            return {
              ...line,
              totalRemised,
            };
          }),
        }));
        setGroups(updatedGroups);
      }
    }
  }, [invoice?.discount]);

  return (
    <>
      {showCalendar && (
              <>
              <div
                onClick={() => setShowCalendar(false)}
                className="grayBlur"
              ></div>
              <Calendar onChange={handleCalendarChange} />
              </>
            )}
        <MailPop
          endpoint={"c-invoice-send-email"}
          id={invoice.id}
          itemName={"Facture"}
          title={refRef.current?.value}
        />
      {((!invoice && loading) || pdfContext.loading) && <Loader />}
      <EditingMainHeader
        roleId={roleId}
        headerTitle={"Facture n°"}
        dateRef={dateRef}
        setShowCalendar={setShowCalendar}
        showCalendar={showCalendar}
        destination={"/invoicesList"}
        endPoint={"c-deactive-invoice"}
        id={invoice?.id}
        refRef={refRef}
        defaultRef={invoice?.ref}
        headerButtonsList={headerButtonsList}
        backRedirect={"/invoicesList"}
      />
      <div className="listPage">
        <div className="invoiceContent">
          <InvoiceFormContainer
            setMargin={setMargin}
            handleSubmitInvoice={handleSubmitInvoice}
            setRefresh={setRefresh}
            setTotalInvoice={setTotalInvoice}
            unitsList={unitsList}
            setGroups={setGroups}
            groups={groups}
            formDatas={formDatas}
            setInvoice={setInvoice}
            vatList={vatList}
            interlocutorsList={interlocutorsList}
            invoice={invoice}
            comment={comment}
            setComment={setComment}
          />
          <RecapContainer
            linkDeposit={linkDeposit}
            invoiceId={invoice?.id}
            handleSubmitInvoice={handleSubmitInvoice}
            deleteDeposit={deleteDeposit}
            totalTtc={invoice?.totalTtc}
            totalHt={invoice?.totalHt}
            discount={invoice?.discount}
            discountPrice={discountPrice}
            createDeposit={createDeposit}
            handleDiscountBlur={handleDiscountBlur}
            handleDiscountChange={handleDiscountChange}
            totalInvoice={totalInvoice}
            vatList={vatList}
            setRefresh={setRefresh}
            margin={margin}
            setMargin={setMargin}
            handleTvaClick={handleTvaClick}
            parent={"invoice"}
            paymentDate={invoice?.paymentDate}
            handleCalendarIconClick={() => setShowCalendar(true)}
            invoice={invoice}
          />
        </div>
      </div>
    </>
  );
}

export default Invoice;
